// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import WechatTemplateSvg from '@rsuite/icon-font/lib/platform/WechatTemplate';
var WechatTemplate = createSvgIcon({
  as: WechatTemplateSvg,
  ariaLabel: 'wechat template',
  category: 'platform',
  displayName: 'WechatTemplate'
});
export default WechatTemplate;